module.exports = __webpack_public_path__ + "static/img/ag_6.5a8e50f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント2/ag_6.png
// module id = 873
// module chunks = 1